export default __webpack_public_path__ + "static/media/image.eyerax-technologies-pvt-ltd-.aed1a5ba.png";